import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
// components
import WebApplicationRedirector from "@/components/WebApplicationRedirector";
import WebApplicationStarter from "@/components/WebApplicationStarter";
import Preloader from "@/components/Preloader";
import InitAnimations from "@/components/InitAnimations";
// layouts
import WebApplicationLayout from "@/cms/layouts/WebApplicationLayout";
// screens
import Home from "@/screens/Home";
import Search from "@/screens/Search";
import Content from "@/screens/Content";
import Page404 from "@/screens/Page404";


type TAppRoutes<T={}> = {

} & T;

const AppRoutes = ( props:TAppRoutes ) => {
    console.log("AppRoutes.rendered: ", props);

    return (
        <BrowserRouter>
            <InitAnimations />
            <Preloader />
            
            <Routes>
                <Route path="/" element={<WebApplicationStarter />} >

                    {/* redirect: language */}
                    <Route index element={<WebApplicationRedirector />} />
                    <Route path="index" element={<WebApplicationRedirector />} />
                    <Route path="home" element={<WebApplicationRedirector />} />

                    {/* redirect: pages */}
                    <Route path=":language" element={<WebApplicationLayout />}>
                        <Route index element={<Home />} />
                        <Route path="search" element={<Search />} />
                        <Route path=":contentName/:contentId" element={<Content />} />

                        {/* redirect: page not fount  */}
                        <Route path="*" element={<Page404 />} />
                    </Route>
                    
                </Route>
            </Routes>

            <ToastContainer />
        </BrowserRouter>
    );

}

const Component = React.memo(AppRoutes, ( prevProps:TAppRoutes, nextProps:TAppRoutes ) => {
    console.log("AppRoutes.memo", { prevProps, nextProps });
    return true;
});

export default Component;
